<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-department-section-dialog-create
          v-if="$hasPermissionTo(['create sections'])"
          @created="loadData"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="Section's Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in section name here"
          append-icon="search"
          label="Search Section"
          hide-no-data
          hide-selected
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="filteredSections"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.name="{ item }">
        <div>
          <span>
            {{ item.name }}
          </span>
        </div>
      </template>

      <template v-slot:item.action="{ item }">
        <span v-if="statusFilter">
          <setup-department-section-dialog-edit
            v-if="$hasPermissionTo(['update sections'])"
            :section="item"
            @updated="loadData"
          />
          <span class="mx-1" />
          <setup-department-section-dialog-delete
            v-if="$hasPermissionTo(['delete sections'])"
            :section="item"
            @deleted="loadData"
          />
        </span>
        <span v-else>
          <setup-department-section-dialog-restore
            v-if="$hasPermissionTo(['restore sections'])"
            :section="item"
            @restored="loadData"
          />
        </span>
      </template>
    </v-data-table> 
  </div>
</template>

<script>
  export default {
    components: {
      SetupDepartmentSectionDialogCreate: () => import('@/components/hris/setup/department/section/DialogCreate'),
      SetupDepartmentSectionDialogDelete: () => import('@/components/hris/setup/department/section/DialogDelete'),
      SetupDepartmentSectionDialogRestore: () => import('@/components/hris/setup/department/section/DialogRestore'),
      SetupDepartmentSectionDialogEdit: () => import('@/components/hris/setup/department/section/DialogEdit'),
    },
    data () {
      return {
        headers: [
          {
            text: 'Sections',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Department',
            align: 'left',
            value: 'department.name',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: true,
        sections: [],
        trashedSections: [],
      }
    },
    computed: {
      filteredSections () {
        return this.statusFilter ? this.sections : this.trashedSections
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        Promise.all([
          this.$api.sections().list([], false),
          this.$api.hrisSections().listTrashed(),
        ]).then(([section, trashedSection]) => {
          this.sections = section.data
          this.trashedSections = trashedSection.data

          this.tableLoading = false
        })
      },
    },
  }
</script>
